import getDefaultValue from '../constants/default_values';
import fieldNames from '../constants/field_names';

/**
 * Formats a value for a field given the output of reading the value
 */
export function transformFieldValue(value, field_name) {
  const formatter = exports.getTransformer(field_name);
  return formatter(value);
}

export function getTransformer(field_name) {
  const formatter = transformerMapping[field_name];
  if (formatter == null) { return defaultTransformer; }
  return formatter;
}

/**
 * Default formatter does nothing but return the value as is
 */
export function defaultTransformer(value) {
  return value;
}

// if the field is empty or null, then set the result to default
// else transform the input values
export function transformPhoneNumber(value) {
  if (value == null || value == '') {
    return getDefaultValue(fieldNames.phoneNumber);
  }
  return value.replace(/[^\d+]/g, '');
}

export function transformCountryCode(value) {
  if (value.match(/country_code/)) {
    return getDefaultValue(fieldNames.countryCode);
  }
  return value;
}

export function transformDialerConsentAccepted(value) {
  if (value) { return true; }
  return false;
}

export const transformerMapping = {
  'phone_number': transformPhoneNumber,
  'country_code': transformCountryCode,
  'dialer_consent_accepted': transformDialerConsentAccepted
};
